import { botCatalog } from '@tentactoe/engine';
import type { Player } from '@tentactoe/engine';
import type { Theme } from '../theme';

export const HUMAN = 'human';

interface GameSetupProps {
  readonly opponent: string;
  readonly onOpponentChange: (opponent: string) => void;
  readonly side: Player;
  readonly onSideChange: (side: Player) => void;
  readonly theme: Theme;
  /** Changing setup mid-game restarts it, so the controls lock once moves exist. */
  readonly disabled: boolean;
}

export function GameSetup({
  opponent,
  onOpponentChange,
  side,
  onSideChange,
  theme,
  disabled,
}: GameSetupProps) {
  const { classes } = theme;
  const versusBot = opponent !== HUMAN;
  const selected = botCatalog.find((bot) => bot.id === opponent);

  return (
    <div className={classes.panel}>
      <div>
        <label className={classes.label} htmlFor="opponent">
          Opponent
        </label>
        <select
          id="opponent"
          className={classes.select}
          value={opponent}
          disabled={disabled}
          onChange={(event) => onOpponentChange(event.target.value)}
        >
          <option value={HUMAN}>Two players</option>
          {botCatalog.map((bot) => (
            <option key={bot.id} value={bot.id}>
              {bot.name} (level {bot.level})
            </option>
          ))}
        </select>
      </div>

      {versusBot && (
        <div>
          <label className={classes.label} htmlFor="side">
            You play
          </label>
          <select
            id="side"
            className={classes.select}
            value={side}
            disabled={disabled}
            onChange={(event) => onSideChange(event.target.value as Player)}
          >
            <option value="X">X (first)</option>
            <option value="O">O (second)</option>
          </select>
        </div>
      )}

      {selected && (
        <p className="text-sm text-gray-600 max-w-xs self-center">{selected.description}</p>
      )}
    </div>
  );
}
